/* ---------- GLOBAL COLORS ---------- */

export const COLOR_BLACK = '#2F2E41';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_LIGHTER_GREY = '#F7F7F8';
export const COLOR_DARKER_GREY = '#F8F8F9';
export const COLOR_PURPLE = '#3A3851';
export const COLOR_DARK_PURPLE = '#262535';
export const COLOR_LIGHT_PURPLE = '#2B2A3C';
export const COLOR_ORANGE = '#F7931E';
export const COLOR_DARK_ORANGE = '#BE7014';
export const COLOR_LIGHT_ORANGE = '#F8AB50';
export const COLOR_BLUE = '#29AAE2';
export const COLOR_RED = '#F71D1D';
export const COLOR_GREEN = '#09BA50';
export const COLOR_LIME_GREEN = '#0CE964';
